import BaseModel from '@/orm/models/BaseModel';

export default class Currency extends BaseModel {
  static entity = 'currencies';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      default: this.boolean(false).nullable(),
      symbol: this.attr(null),
    };
  }

  static apiConfig = {}
}
